import AuthService from '../../services/AuthService'
import router from '../../router'

const state = () => ({
    isAuthenticated: false,
    loadingUser: false,
    redirect: localStorage.getItem('redirect') || '/',
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user')) || null,
    user_confirmation: false,
})
  
const mutations = {
    SET_REDIRECT: (state, payload) => {
        state.redirect = payload;
        localStorage.setItem('redirect', payload);
    },
    REGISTER_USER: (state) => {
        state.user_confirmation = true;
    },
    SET_USER: (state, payload) => {
        localStorage.setItem('token', payload.token);
        localStorage.setItem('user', JSON.stringify(payload));

        const backPage = state.redirect;
        state.redirect = '/';
        state.isAuthenticated = true;
        state.user = payload.user;
        state.token = payload.token;
        if(router.currentRoute.path === '/auth' && !backPage){
            router.push({path: `/`});
        }else{
            router.push({path: `${backPage}`});
        }
        state.redirect = '/';
    },
    AUTH_USER: (state, payload) => {
        localStorage.setItem('token', payload.token)
        localStorage.setItem('user', JSON.stringify(payload));
       
        state.isAuthenticated = true;
        state.user = payload;
    },
    SET_LOADING_USER: (state, payload) => {
        state.loadingUser = payload
    },
    LOG_USER_OUT(state){
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('notifications');
        localStorage.removeItem('subjects');
        localStorage.removeItem('aulasAssistidas');
        localStorage.removeItem('pages');
        localStorage.removeItem('page');
        state.token = null;
        state.isAuthenticated = false;
        state.user = null;
        state.notifications = [];
        state.redirect = '/';
        if(router.currentRoute.value.path !== '/auth'){
            router.push({path: `/auth`});
        }
    },
    SET_USER_REGISTER(state, data) {
        state.userRegister = data;
    },
    LIMPAR_REGISTER(state) {
        localStorage.removeItem('register');
        localStorage.removeItem('registerSteps');

        state.userRegister = null;
        state.registerSteps = 1;
        state.register = {
            pessoais: null,
            especificos: null,
            enderecos: null
        };
    },
    SET_DADOS_PESSOAIS(state, data) {
        state.register.pessoais = data;
        localStorage.setItem('register', JSON.stringify(state.register));
    },
    SET_DADOS_ESPECIFICOS(state, data) {
        state.register.especificos = data;
        localStorage.setItem('register', JSON.stringify(state.register));
    },
    SET_DADOS_ENDERECO(state, data) {
        state.register.enderecos = data;
        localStorage.setItem('register', JSON.stringify(state.register));
    },
    SET_STAGE_REGISTER(state, etapa) {
        state.registerSteps= etapa;
        localStorage.setItem('registerSteps', JSON.stringify(etapa));
    },
    SET_BACK_STAGE_REGISTER(state) {
        state.registerSteps = --state.registerSteps;
    },
}

const actions = {
    async loginUser({commit, dispatch}, credentials ){
        try {
            commit('SET_LOADING_USER', true);
            const response = await AuthService.login(credentials);
            if(response.data.user.status == 'pendente'){
                dispatch('sendNewAccount', response.data.user, { root: true })
                commit('REGISTER_USER'); 
                commit('SET_ALERT', {
                    heading: 'success',
                    message: response.data.message
                });
            } else if(response.data.user.status == 'ativo'){
                commit('SET_USER', response.data);
            }
            commit('SET_LOADING_USER', false);
        } catch (error) {
            commit('SET_LOADING_USER', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async registerUser({commit, dispatch}, credentials){
        try{
            commit('SET_LOADING_USER', true);
            const response = await AuthService.create(credentials);
            dispatch('sendNewAccount', response.data.user, { root: true })
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('REGISTER_USER'); 
            commit('SET_LOADING_USER', false);
        }catch(error){
            commit('SET_LOADING_USER', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async registerUserAgain({commit, dispatch}, credentials){
        try{
            commit('SET_LOADING_USER', true);
            const response = await AuthService.createAgain(credentials);
            dispatch('sendNewAccount', response.data, { root: true })
            commit('SET_LOADING_USER', false);
        }catch(error){
            commit('SET_LOADING_USER', false);
            commit('LOG_USER_OUT')
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async confirmUser({commit}, credentials){
        try{
            commit('SET_LOADING_USER', true);
            const response = await AuthService.confirmUser(credentials.token);
            if(response.data.user.status == 'ativo'){
                commit('SET_ALERT', {
                    heading: 'success',
                    message: response.data.message
                });
            }
            setTimeout(() => {
                if(response.data.user.status == 'ativo'){
                    window.location.replace('/');
                    commit('SET_USER', response.data);
                }
            }, 4000);
            commit('SET_LOADING_USER', false);
        }catch(error){
            commit('SET_LOADING_USER', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchUser({commit}){
        try{
            commit('SET_LOADING_USER', true)
            const response = await AuthService.getUser();
            commit('AUTH_USER', response.data)
            commit('SET_LOADING_USER', false)
        } catch (error) {
            commit('SET_LOADING_USER', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updateUser({commit}, payload){
        try {
            commit('SET_LOADING_USER', true)
            await AuthService.update(payload);
            commit('SET_LOADING_USER', false);
        } catch (error) {
            commit('SET_LOADING_USER', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getUser: state => state.user,
    getLoadingUser: state => state.loadingUser,
    getConfirmation: state => state.user_confirmation,
}

export default {
    state,
    getters,
    mutations,
    actions
};